import { removeCpfMask, STATUSPAGE } from '@repo/ui';
import { AuthenticationSendPasswordResetCodeUseCaseInterface } from 'domain/usecases';
import { useFormik } from 'formik';
import { notifyError, notifySuccess } from 'presentation/app/components/notify';
import { usePasswordResetFlow } from 'presentation/app/contexts/PasswordResetFlowContext';
import { useService } from 'presentation/app/hooks/useService';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

export const useRequestResetPassword = () => {
  //hooks
  const { authenticationService } = useService();
  const { setCpf } = usePasswordResetFlow();
  const navigate = useNavigate();
  const [loadingSendPasswordResetCode, setLoadingSendPasswordResetCode] =
    useState<STATUSPAGE>(STATUSPAGE.DONE);

  // validation
  const validationSendPasswordResetCode = useFormik({
    enableReinitialize: true,

    initialValues: {
      cpf: '',
    },
    validationSchema: Yup.object({
      cpf: Yup.string().required('Campo obrigatório'),
    }),
    onSubmit: (
      values: AuthenticationSendPasswordResetCodeUseCaseInterface.Params,
    ) => {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      requestSendPasswordResetCode({
        cpf: removeCpfMask(values.cpf),
      });
    },
  });

  // request
  const requestSendPasswordResetCode = useCallback(
    (params: AuthenticationSendPasswordResetCodeUseCaseInterface.Params) => {
      setLoadingSendPasswordResetCode(STATUSPAGE.LOADING);
      authenticationService
        .authenticationSendPasswordResetCode(params)
        .then((res) => {
          // Atualiza o contexto com o CPF e avança para a próxima etapa
          setCpf(params.cpf);
          navigate('/redefinir-senha/codigo-verificacao');
          notifySuccess(
            res.message || 'Código de redefinição enviado com sucesso.',
          );
        })
        .catch((error: unknown) => {
          if (error instanceof Error) {
            notifyError(
              error.message || 'Erro ao enviar código de redefinição.',
            );
          }
        })
        .finally(() => {
          setLoadingSendPasswordResetCode(STATUSPAGE.DONE);
        });
    },
    [authenticationService, setCpf, navigate],
  );

  return {
    requestSendPasswordResetCode,
    loadingSendPasswordResetCode,
    validationSendPasswordResetCode,
  };
};
